// Placeholder analytics until the page is connected to Google Analytics (IBEX-1278).
// Shapes are what the real integration should return.

export interface AnalyticsKpi {
    label: string
    value: string
    change: number // % vs previous period
}

export interface AnalyticsDailyPoint {
    date: string
    users: number
    sessions: number
}

export interface AnalyticsPageRow {
    page: string
    module: string
    views: number
    users: number
    avgTimeSec: number
}

export interface AnalyticsUserRow {
    name: string
    department: string
    sessions: number
    lastSeen: string
}

export const ANALYTICS_KPIS: AnalyticsKpi[] = [
    { label: "Active Users", value: "142", change: 8.4 },
    { label: "Sessions", value: "1,936", change: 5.1 },
    { label: "Page Views", value: "11,284", change: -2.3 },
    { label: "Avg. Session", value: "6m 12s", change: 3.7 },
]

export const ANALYTICS_DAILY: AnalyticsDailyPoint[] = Array.from({ length: 30 }, (_, i) => {
    const d = new Date(2026, 9, i + 1)
    const weekend = d.getDay() === 0 || d.getDay() === 6
    const base = weekend ? 18 : 95
    return {
        date: d.toLocaleDateString("en-CA", { month: "short", day: "numeric" }),
        users: base + ((i * 7) % 23),
        sessions: Math.round((base + ((i * 7) % 23)) * 1.4),
    }
})

export const ANALYTICS_PAGES: AnalyticsPageRow[] = [
    { page: "Billability / Utilization", module: "Finance", views: 2140, users: 88, avgTimeSec: 312 },
    { page: "Projects", module: "Project Managment", views: 1985, users: 74, avgTimeSec: 254 },
    { page: "Project WIH Forecast", module: "Project Managment", views: 1422, users: 41, avgTimeSec: 540 },
    { page: "Employees", module: "Human Resources", views: 1210, users: 52, avgTimeSec: 140 },
    { page: "Consulting Income", module: "Finance", views: 860, users: 33, avgTimeSec: 205 },
    { page: "Gross Margin", module: "Finance", views: 744, users: 29, avgTimeSec: 233 },
    { page: "Agreement Generator", module: "Human Resources", views: 612, users: 17, avgTimeSec: 410 },
    { page: "Opportunity Forecast", module: "Business Development", views: 588, users: 21, avgTimeSec: 366 },
]

export const ANALYTICS_USERS: AnalyticsUserRow[] = [
    { name: "Sample User A", department: "Calgary Engineering", sessions: 64, lastSeen: "2026-10-31" },
    { name: "Sample User B", department: "Vancouver Geotechnical", sessions: 51, lastSeen: "2026-10-31" },
    { name: "Sample User C", department: "Finance", sessions: 47, lastSeen: "2026-10-30" },
    { name: "Sample User D", department: "Human Resources", sessions: 39, lastSeen: "2026-10-29" },
    { name: "Sample User E", department: "Project Controls", sessions: 22, lastSeen: "2026-10-27" },
]
